// <s-sticky-buy> reveals a fixed mobile buy bar once the main add-to-cart button
// scrolls out of view. The target is found via the data-target selector inside the
// closest product form wrapper.
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const scope = this.closest('[data-product-form]') || document;
    const target = scope.querySelector(this.dataset.target || '[data-main-add]');
    this.#hide();
    if (!target) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (passed) {
        this.#show();
      } else {
        this.#hide();
      }
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #show() {
    this.setAttribute('data-visible', '');
    this.inert = false;
    this.removeAttribute('aria-hidden');
  }

  #hide() {
    this.removeAttribute('data-visible');
    this.inert = true;
    this.setAttribute('aria-hidden', 'true');
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', SStickyBuy);
}
